module.exports = __webpack_public_path__ + "img/new-risk-button.89cfb23d.png";